import { render, staticRenderFns } from "./BasicOverlay.vue?vue&type=template&id=0ba2c093"
import script from "./BasicOverlay.vue?vue&type=script&lang=js"
export * from "./BasicOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports